module.exports = __webpack_public_path__ + "img/IBKR_rebalance.c3d20c8e.png";